var t = /* @__PURE__ */ ((r) => (r.Background = "iress--background", r.Base = "iress-u-panel", r.NoBorderRadius = "iress--no-border-radius", r.NoGutter = "iress--no-gutter", r.Stretch = "iress--stretch", r))(t || {}), e = /* @__PURE__ */ ((r) => (r.Default = "default", r.Alt = "alt", r.Page = "page", r.Transparent = "transparent", r))(e || {});
const u = [
  "default",
  "alt",
  "page",
  "transparent"
];
export {
  u as PANEL_BACKGROUNDS,
  e as PanelBackground,
  t as PanelCssClass
};
